export default __webpack_public_path__ + "static/media/stop-icon.e28b70cc.svg";